import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EasyClaimCaseResponseDto } from 'src/easyclaim.api.client.typescript/src';
import styled from 'styled-components';

import { IconLike } from '../easyclaim.app.assets/index';
import {
	StyledIconMenu,
	CenteredCircle,
	DetailContainer,
	MenuContainer,
	HamburgerContainer,
	Header,
	Main,
} from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

interface ThanksForFeedbackProps {
	onMenu: () => void;

	easyClaimCase: EasyClaimCaseResponseDto;
	changeCase: (func: (easyClaimCase: EasyClaimCaseResponseDto) => EasyClaimCaseResponseDto) => void;
	onSendFeedback: () => void;
}

export class ThanksForFeedback extends ScreenComponent<ThanksForFeedbackProps, {}> {
	constructor(props: ThanksForFeedbackProps) {
		super(props);

		this.state = {};
	}

	public render() {
		return (
			<div className="main-container">
				<Header>
					<MenuContainer>
						<HamburgerContainer onClick={this.props.onMenu}>
							<StyledIconMenu />
						</HamburgerContainer>
					</MenuContainer>
				</Header>
				<Main>
					<h2 className="thanks-for-feedback-title">
						<FormattedMessage id="thanksForFeedback.headline.first" />
					</h2>
					<DetailContainer>
						<CenteredCircle
							className="like-circle"
							size="6rem"
							borderColor={theme.colors.success}
							borderStyle="solid"
							borderWidth="3px"
						>
							<StyledLikeIcon className="like-icon" />
						</CenteredCircle>
						<Paragraph>
							<FormattedMessage id="thanksForFeedback.paragraph.first" />
						</Paragraph>
					</DetailContainer>
				</Main>
			</div>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
`;

const StyledLikeIcon = styled(IconLike)`
	height: 4rem;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.success};
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;
